import { NgClass } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [FlexLayoutModule, TranslatePipe, NgClass],
  selector: 'iot-platform-ui-card-loader',
  templateUrl: './card-loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./card-loader.component.scss']
})
export class CardLoaderComponent {
  backgroundClass = input<string>('');
}
